"use client"

import * as React from "react"

/** Demo_screens legacy UI navigation inside hosted iframe embeds. */
export type StepsEmbedNavMode = "tabs" | "sidebar"

const STORAGE_KEY = "demo:embed-nav-mode:v1"
const CHANGE_EVENT = "demo-embed-nav-mode-change"

export function getStepsEmbedNavMode(): StepsEmbedNavMode {
  if (typeof window === "undefined") return "tabs"
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored === "sidebar" ? "sidebar" : "tabs"
}

export function setStepsEmbedNavMode(mode: StepsEmbedNavMode): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(STORAGE_KEY, mode)
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT))
}

export function useStepsEmbedNavMode(): [StepsEmbedNavMode, (mode: StepsEmbedNavMode) => void] {
  const [mode, setModeState] = React.useState<StepsEmbedNavMode>(() => getStepsEmbedNavMode())

  React.useEffect(() => {
    const sync = () => setModeState(getStepsEmbedNavMode())
    window.addEventListener(CHANGE_EVENT, sync)
    return () => window.removeEventListener(CHANGE_EVENT, sync)
  }, [])

  const setMode = React.useCallback((next: StepsEmbedNavMode) => {
    setStepsEmbedNavMode(next)
    setModeState(next)
  }, [])

  return [mode, setMode]
}

export function subscribeStepsEmbedNavMode(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => {}
  window.addEventListener(CHANGE_EVENT, onChange)
  return () => window.removeEventListener(CHANGE_EVENT, onChange)
}
